export default __webpack_public_path__ + "static/media/legato_logo.b21d6f55.png";